import { CreditCardIcon } from '@heroicons/react/24/outline';
import { GQLVaultedCardTypeType } from '@theprintbar/graphql';
import { ComponentProps } from 'react';
import { AmexIcon } from './icons/Amex';
import { DiscoverIcon } from './icons/DIscover';
import { DinersIcon } from './icons/Diners';
import { JCBIcon } from './icons/JCB';
import { MastercardIcon } from './icons/Mastercard';
import { VisaIcon } from './icons/Visa';

interface CreditCardProviderIconProps extends ComponentProps<'svg'> {
	cardType?: GQLVaultedCardTypeType;
}

export function CreditCardProviderIcon({ cardType, ...props }: CreditCardProviderIconProps) {
	switch (cardType) {
		case GQLVaultedCardTypeType.Mastercard:
			return <MastercardIcon {...props} />;
		case GQLVaultedCardTypeType.Visa:
			return <VisaIcon {...props} />;
		case GQLVaultedCardTypeType.Amex:
			return <AmexIcon {...props} />;
		case GQLVaultedCardTypeType.Diners:
			return <DinersIcon {...props} />;
		case GQLVaultedCardTypeType.Jcb:
			return <JCBIcon {...props} />;
		case GQLVaultedCardTypeType.Discover:
			return <DiscoverIcon {...props} />;
		default:
			return <CreditCardIcon {...props} />;
	}
}
